import css from 'styled-jsx/css'

export default css`
  .wrapper-play-audio {
    max-width: 40rem;
    margin: 0 auto;
    padding-top: 1rem;
  }

  .progress {
    padding-top: 0.5rem;
  }
`
export const buttonsStyles = css`
  .btn-control :global(i) {
    font-weight: bold;
    font-size: 1rem;
  }
`
